import { render, staticRenderFns } from "./modal-resumo-antecipacao.vue?vue&type=template&id=57fe5fc0&scoped=true"
import script from "./modal-resumo-antecipacao.vue?vue&type=script&lang=ts"
export * from "./modal-resumo-antecipacao.vue?vue&type=script&lang=ts"
import style0 from "./modal-resumo-antecipacao.vue?vue&type=style&index=0&id=57fe5fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe5fc0",
  null
  
)

export default component.exports